
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Fliegen Sie noch? Vielen Reisenden ist bewusst, dass der Flugverkehr einer der hauptsächlichen Verursacher von Treibhausgasen ist. Das zeigt unsere Umfrage auf dem Flughafen Zürich. Trotzdem kompensiert kaum jemand den Flug. Wir haben mithilfe von Ökobilanz-Experten des Beratungsunternehmens ESU-Services berechnet, wie viel Treibhausgase bei verschiedenen Flügen auf einen einzelnen Fluggast entfallen. Und wir zeigen auf, wie sie diese Klimabelastung kompensieren könnten.`}</p>
    <p>{`Doch bringt das überhaupt noch etwas? Der wissenschaftliche Konsens lautet, dass die Treibhausgas-Emissionen möglichst rasch auf netto null runtermüssen, damit wir eine katastrophale Klimaerhitzung noch verhindern können. Das heisst, weder reine Effizienzmassnahmen bei fossilen Antrieben und Heizungen noch Kompensationen sind ein wirksames Mittel zur Erreichung dieses Ziels. Christoph Meili, Ökobilanzierer bei ESU-services, sagt: «Wir müssen komplett weg von fossilen Energieträgern wie Erdöl, Erdgas und Kohle!»`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;